module.exports = __webpack_public_path__ + "img/DDBU_Logo.e5588635.png";